<template>
  <div class="receipt-page">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="receipt-wrapper">
            <!-- Main Content Header -->
            <div class="my-content-header">
              <div class="header-left">
                <div class="header-icon-wrapper">
                  <feather-icon
                    icon="FileTextIcon"
                    size="28"
                    class="header-icon"
                  />
                </div>
                <div>
                  <div class="main-title">
                    LẬP PHIẾU THU KHOẢN THU KHÁC
                  </div>
                  <div class="voucher-code">
                    Số phiếu: {{ currentReceipt.code }}
                  </div>
                </div>
              </div>
              <div class="header-right">
                <div class="receipt-type-toggle mr-2">
                  <b-button
                    size="sm"
                    :variant="isTuitionReceipt ? 'primary' : 'outline-primary'"
                    @click="switchToTuition"
                  >
                    Thu học phí
                  </b-button>
                  <b-button
                    size="sm"
                    :variant="!isTuitionReceipt ? 'primary' : 'outline-primary'"
                    @click="switchToOtherRevenue"
                  >
                    Khoản thu khác
                  </b-button>
                </div>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-modal.historyModal
                  class="mr-2 history-btn"
                >
                  <feather-icon
                    icon="ClockIcon"
                    size="16"
                    class="mr-1"
                  />
                  LỊCH SỬ THU
                </b-button>
                <b-button
                  variant="outline-secondary"
                  size="sm"
                >
                  <feather-icon
                    icon="SettingsIcon"
                    size="16"
                  />
                </b-button>
              </div>
            </div>

            <!-- Main Content - 2 Columns Layout -->
            <b-row>
              <!-- Left Panel - Student Info & Revenue Details -->
              <b-col
                cols="8"
                class="left-panel"
              >
                <!-- Student Information Section -->
                <div class="content-card">
                  <div class="section-title">
                    <span class="title-bar" />THÔNG TIN SINH VIÊN
                  </div>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group
                        label-for="code_student"
                      >
                        <label class="required-label">
                          Mã sinh viên <span class="text-danger">*</span>
                        </label>
                        <b-form-input
                          id="student-code"
                          v-model="filter.code_student"
                          name="code_student"
                          placeholder="Nhập mã..."
                          @keydown.enter.native="getReceiptByCode"
                          @input="codeStudentChanged"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-group
                        label="Họ và tên"
                        label-for="full-name"
                      >
                        <b-form-input
                          id="full-name"
                          :value="`${currentReceipt.last_name || ''} ${currentReceipt.first_name || ''}`.trim()"
                          name="full-name"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group
                        label="Ngày sinh"
                        label-for="birthday"
                      >
                        <b-form-input
                          id="birthday"
                          :value="currentReceipt.birthday"
                          name="birthday"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        label="Giới tính"
                        label-for="gender"
                      >
                        <b-form-input
                          id="gender"
                          :value="getGender(currentReceipt.gender)"
                          name="gender"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        label="Lớp"
                        label-for="class-name"
                      >
                        <b-form-input
                          id="class-name"
                          :value="currentReceipt.class_name"
                          name="class-name"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group
                        label="Khóa học"
                        label-for="course-name"
                      >
                        <b-form-input
                          id="course-name"
                          :value="currentReceipt.course_name"
                          name="course-name"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        label="Ngành học"
                        label-for="major-name"
                      >
                        <b-form-input
                          id="major-name"
                          :value="currentReceipt.major_name"
                          name="major-name"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        label="Nơi sinh"
                        label-for="birth-place"
                      >
                        <b-form-input
                          id="birth-place"
                          :value="currentReceipt.birth_place"
                          name="birth-place"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group
                        label="Ngày nộp phiếu"
                        label-for="receipt-date"
                        class="date-picker-group"
                      >
                        <div class="date-picker-wrapper">
                          <flat-pickr
                            v-model="filter.day"
                            :config="config"
                            class="form-control"
                            placeholder="Chọn ngày"
                            name="receipt-date"
                          />
                          <feather-icon
                            icon="CalendarIcon"
                            size="18"
                            class="date-icon"
                          />
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        label="Loại đối tượng ưu tiên"
                        label-for="policies-name"
                      >
                        <b-form-input
                          id="policies-name"
                          :value="currentReceipt.policies_name || 'Không có'"
                          name="policies-name"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>

                <!-- Khoản Thu Khác Section -->
                <div class="content-card">
                  <div class="section-title">
                    <span class="title-bar" />KHOẢN THU KHÁC
                  </div>
                  <div class="debt-table-wrapper">
                    <b-table
                      :items="revenue_items"
                      :fields="debtTableFields"
                      class="debt-table"
                      hover
                    >
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(revenue_info)="data">
                        <div>
                          <div class="subject-name">{{ data.item.revenue_name }}</div>
                          <div class="semester-name">{{ data.item.semester_name }}</div>
                        </div>
                      </template>
                      <template #cell(amount)="data">
                        <span class="amount-value">
                          {{ formatNumber(data.item.amount) }}
                        </span>
                      </template>
                    </b-table>
                  </div>
                </div>

                <!-- Reason & Notes Section -->
                <div class="content-card">
                  <b-form-group
                    label="LÝ DO NỘP &amp; GHI CHÚ"
                    label-for="reason"
                  >
                    <b-form-textarea
                      id="reason"
                      v-model="currentReceipt.reason"
                      name="reason"
                      placeholder="Nhập lý do thu tiền..."
                      rows="3"
                      :disabled="true"
                    />
                  </b-form-group>
                </div>
              </b-col>

              <!-- Right Panel - Payment Summary -->
              <b-col
                cols="4"
                class="right-panel"
              >
                <div class="summary-card">
                  <div class="summary-header">
                    <feather-icon
                      icon="DollarSignIcon"
                      size="18"
                      class="summary-icon"
                    />
                    <span>TỔNG HỢP THANH TOÁN</span>
                  </div>
                  <div class="summary-content">
                    <div class="summary-row">
                      <div class="summary-label">Tổng tiền thu</div>
                      <div class="summary-amount">
                        {{ formatNumber(currentReceipt.amount || 0) }}
                      </div>
                    </div>
                    <div class="summary-row highlight-row">
                      <div class="summary-label">THỰC THU (VNĐ)</div>
                      <div class="summary-amount-large">
                        {{ formatNumber(currentReceipt.amount || 0) }}
                      </div>
                    </div>
                    <div class="summary-row">
                      <div class="summary-label">Bằng chữ</div>
                      <div class="amount-word">
                        {{ currentReceipt.amount_word || '' }}
                      </div>
                    </div>
                  </div>

                  <div class="payment-method-section">
                    <div class="summary-label">HÌNH THỨC NỘP</div>
                    <b-row>
                      <b-col cols="6">
                        <div
                          class="payment-option"
                          :class="{ active: paymentMethod === 'cash' }"
                          @click="paymentMethod = 'cash'"
                        >
                          <div class="payment-radio">
                            <div
                              class="radio-circle"
                              :class="{ checked: paymentMethod === 'cash' }"
                            />
                          </div>
                          <span>Tiền mặt</span>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div
                          class="payment-option"
                          :class="{ active: paymentMethod === 'transfer' }"
                          @click="paymentMethod = 'transfer'"
                        >
                          <div class="payment-radio">
                            <div
                              class="radio-circle"
                              :class="{ checked: paymentMethod === 'transfer' }"
                            />
                          </div>
                          <span>Chuyển khoản</span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    v-show="!currentReceipt.code && creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    block
                    size="lg"
                    class="confirm-button"
                    @click="onCreate"
                  >
                    <feather-icon
                      icon="SaveIcon"
                      size="20"
                    />
                    XÁC NHẬN LƯU PHIẾU
                  </b-button>
                  <b-button
                    v-show="!!currentReceipt.code"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    block
                    size="lg"
                    class="confirm-button"
                    @click="onPrint"
                  >
                    <feather-icon
                      icon="PrinterIcon"
                      size="18"
                      class="mr-2"
                    />
                    Xem trước &amp; In
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <vue-html2pdf
      ref="html2PdfRef"
      :show-layout="controlValue.showLayout"
      :float-layout="controlValue.floatLayout"
      :enable-download="controlValue.enableDownload"
      :preview-modal="controlValue.previewModal"
      :filename="controlValue.filename"
      :paginate-elements-by-height="controlValue.paginateElementsByHeight"
      :pdf-quality="controlValue.pdfQuality"
      :pdf-format="controlValue.pdfFormat"
      :pdf-orientation="controlValue.pdfOrientation"
      :pdf-content-width="controlValue.pdfContentWidth"
      :manual-pagination="controlValue.manualPagination"
      :html-to-pdf-options="htmlToPdfOptions"
    >
      <pdf-content
        slot="pdf-content"
        :data="itemPrint"
      />
    </vue-html2pdf>
    <HistoryReceipt
      ref="historyFormRef"
      :student-classes-id="currentReceipt.student_classes_id"
    />
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BFormTextarea,
  BTable,
  BContainer,
  BFormGroup,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { GENDERS } from '@/const/status'
import VNnum2words from 'vn-num2words'
import { getUser } from '@/auth/utils'
import flatPickr from 'vue-flatpickr-component'
import PdfContent from '@/views/finance/receipt/PdfContent.vue'
import receiptApi from '@/views/finance/receipt/api'
import HistoryReceipt from '@/views/finance/receipt/History.vue'
import VueHtml2pdf from 'vue-html2pdf'
// eslint-disable-next-line import/extensions,import/no-extraneous-dependencies
import { vn } from 'flatpickr/dist/l10n/vn.js'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'ReceiptKTK',
  directives: {
    Ripple,
  },
  components: {
    HistoryReceipt,
    BTable,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BButton,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    PdfContent,
    VueHtml2pdf,
    flatPickr,
  },
  data() {
    return {
      isLoading: false,
      isCreateReceipt: true,
      filter: {
        code_student: null,
        day: new Date(),
      },
      currentReceipt: {
        course_semester_id: null,
        student_classes_id: null,
        reason: null,
        amount: null,
        amount_word: null,
        total: null,
        total_exemption: null,
        code: null,
        id: null,
        last_name: null,
        first_name: null,
        gender: null,
        birthday: null,
        birth_place: null,
        class_name: null,
        major_name: null,
        course_name: null,
        policies_name: null,
        revenue_name: null,
        collecter_id: null,
        collection_time: null,
        status: 1,
      },
      revenue_fields: [
        { key: 'semester_name', label: 'Kỳ học' },
        { key: 'revenue_name', label: 'Loại khoản thu khác' },
        { key: 'amount', label: 'Số tiền' },
      ],
      debtTableFields: [
        { key: 'index', label: '#' },
        { key: 'revenue_info', label: 'HỌC KỲ / KHOẢN THU KHÁC' },
        { key: 'amount', label: 'SỐ TIỀN' },
      ],
      revenue_items: [],
      paymentMethod: 'cash',
      // API Response data
      listStudentInfo: [],
      listRevenuesKTK: [],
      listRevenuesKTKTotal: [],
      config: {
        wrap: true,
        enableTime: false,
        altInput: true,
        altFormat: 'Y-m-d',
        dateFormat: 'Y-m-d',
        locale: vn,
        // minDate: 'today',
      },
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: false,
        previewModal: true,
        paginateElementsByHeight: 1200,
        manualPagination: false,
        filename: 'PhieuThuHocPhi',
        pdfQuality: 2,
        pdfFormat: 'a5',
        pdfOrientation: 'landscape',
        pdfContentWidth: '800px',
      },
      itemPrint: {
        name: '',
        address: '',
        content: '',
        amount: '',
        amount_word: '',
        date: '',
      },
    }
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: 'PhieuThu.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: 'in',
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      }
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.RECEIPT)
    },
    isTuitionReceipt() {
      return this.$route.name === 'receipt'
    },
  },
  async created() {
    this.isLoading = false
  },
  methods: {
    async getReceiptKTK(params) {
      const [studentInfo, revenuesKTKTotal, revenuesKTK] = await Promise.all([
        receiptApi.getReceiptStudentInfo(params),
        receiptApi.getReceiptKTKTotal(params),
        receiptApi.getReceiptKTKRevenues(params),
      ])
      this.listStudentInfo = studentInfo
      this.listRevenuesKTKTotal = revenuesKTKTotal
      this.listRevenuesKTK = revenuesKTK
    },
    async createReceiptKTK(params) {
      return receiptApi.createReceiptKTK(params)
    },
    formatNumber(value) {
      if (value == null) return '0'
      return new Intl.NumberFormat('vi-VN').format(value)
    },
    switchToTuition() {
      if (this.$route.name !== 'receipt') {
        this.$router.push({ name: 'receipt' })
      }
    },
    switchToOtherRevenue() {
      if (this.$route.name !== 'receiptktk') {
        this.$router.push({ name: 'receiptktk' })
      }
    },
    async onCreate() {
      try {
        this.currentReceipt.code = `#${Date.now()}`
        this.currentReceipt.collecter_id = getUser().employeeId
        this.currentReceipt.collection_time = this.filter.day
        this.currentReceipt.status = 2
        await this.createReceiptKTK(this.currentReceipt)
        this.isCreateReceipt = false
        this.isLoading = false
        showSuccessToast(this, 'Tạo mới phiếu thu thành công')
        await this.getReceiptByCode()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async getReceiptByCode() {
      if (this.filter.code_student == null || this.filter.day === '') {
        showErrorToast(this, 'Mã số sinh viên hoặc ngày nộp đang để trống')
      } else {
        this.isLoading = true
        try {
          await this.getReceiptKTK(this.filter)
          this.currentReceipt = {
            ...this.currentReceipt,
            ...this.listStudentInfo[0],
          }
          this.currentReceipt.amount_word = this.getAmountWord(
            this.currentReceipt.amount,
          )
          this.revenue_items = this.listRevenuesKTK
          if (this.currentReceipt.collection_time != null) {
            this.filter.day = this.currentReceipt.collection_time
          }

          // Wait for DOM to render completely before hiding loading
          await this.$nextTick()
          // Additional wait for content to fully render
          await new Promise(resolve => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve)
            })
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    getGender(id) {
      if (id !== null) {
        const rs = GENDERS.find(gender => gender.value === id)
        return (rs === undefined ? 'Không xác định' : rs.label)
      }
      return null
    },
    getAmountWord(amount) {
      if (amount !== null) {
        // eslint-disable-next-line camelcase
        const amount_word = VNnum2words(amount)
        return `${
          amount_word.charAt(0).toUpperCase() + amount_word.slice(1)
        } đồng`
      }
      return null
    },
    async onPrint() {
      this.isLoading = true
      try {
        this.itemPrint.name = getUser().fullName
        this.itemPrint.address = getUser().department_name
        this.itemPrint.content = `Thu tiền ${this.currentReceipt.reason.toLowerCase()} của sinh viên ${this.currentReceipt.last_name} ${this.currentReceipt.first_name} - Lớp ${this.currentReceipt.course_name} ${this.currentReceipt.class_name}`
        this.itemPrint.amount = new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
        }).format(this.currentReceipt.amount)
        this.itemPrint.amount_word = this.getAmountWord(this.currentReceipt.amount)
        this.itemPrint.date = `Ngày ${this.currentReceipt.collection_time.substring(8, 10)} tháng ${this.currentReceipt.collection_time.substring(5, 7)} năm ${this.currentReceipt.collection_time.substring(0, 4)}`
        this.$refs.html2PdfRef.generatePdf()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    codeStudentChanged() {
      this.currentReceipt = {}
      this.currentReceipt.gender = null
      this.currentReceipt.amount = null
      this.revenue_items = []
      this.paymentMethod = 'cash'
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.receipt-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

// Top Navigation Bar
.top-navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #e4e7ec;
  padding: 0.75rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  .navbar-left {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .nav-icon {
      font-size: 20px;
      color: #5a60f8;
    }

    .nav-title {
      font-weight: 500;
      font-size: 14px;
      color: #1a1a1a;
    }
  }

  .navbar-center {
    display: flex;
    gap: 0.75rem;

    .nav-icon-small {
      font-size: 16px;
      color: #667085;
      cursor: pointer;

      &:hover {
        color: #5a60f8;
      }
    }
  }

  .navbar-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .nav-icon-small {
      font-size: 16px;
      color: #667085;
      cursor: pointer;
    }

    .code-select {
      width: 100px;
      font-size: 12px;
    }
  }
}

.receipt-wrapper {
  padding: 1.5rem;
}

// Left and Right Panel Borders
.left-panel {
  border-right: 1px solid #e4e7ec;
  padding-right: 1.5rem;
}

.right-panel {
  border-left: 1px solid #e4e7ec;
  padding-left: 1.5rem;
}

// Main Content Header
.my-content-header {
  background-color: #ffffff;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid gray;

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;

    .header-icon-wrapper {
      background-color: #f0f0ff;
      padding: 0.75rem;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      .header-icon {
        color: #5a60f8;
      }
    }

    .main-title {
      font-weight: 700;
      font-size: 20px;
      color: #1a1a1a;
      margin-bottom: 0.25rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .title-icon {
        color: #5a60f8;
      }
    }

    .voucher-code {
      font-size: 13px;
      color: #667085;
    }
  }

  .header-right {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
}

.receipt-type-toggle {
  display: inline-flex;

  .btn {
    border-radius: 6px;
  }

  .btn + .btn {
    margin-left: 6px;
  }
}

// Content Cards
.content-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .section-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .title-bar {
      width: 4px;
      height: 20px;
      background-color: #5a60f8;
      border-radius: 2px;
    }
  }

  .required-label {
    font-size: 13px;
    color: #1a1a1a;
    margin-bottom: 0.25rem;
    display: block;
  }

  .date-picker-group {
    .date-picker-wrapper {
      position: relative;

      .date-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #667085;
        pointer-events: none;
        z-index: 10;
        width: 18px;
        height: 18px;
      }
    }
  }
}

// Debt Table
.debt-table-wrapper {
  border: 1px solid #e4e7ec;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1rem;

  .debt-table {
    margin-bottom: 0;

    .subject-name {
      font-weight: 500;
      color: #1a1a1a;
      margin-bottom: 0.25rem;
    }

    .semester-name {
      font-size: 12px;
      color: #667085;
    }

    .amount-value {
      color: #5a60f8;
      font-weight: 600;
    }
  }
}

.table-summary {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background-color: #f9fafb;
  border-top: 1px solid #e4e7ec;
  font-size: 13px;
  color: #667085;

  .summary-left,
  .summary-right {
    strong {
      color: #1a1a1a;
      font-weight: 600;
    }
  }
}

.empty-exemption {
  padding: 2rem 1rem;
  border: 1px dashed #e4e7ec;
  border-radius: 6px;
  background-color: #f9fafb;
}

// Summary Card (Right Panel)
.summary-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 1rem;

  .summary-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 1.25rem;
    color: #1a1a1a;

    .summary-icon {
      color: #5a60f8;
    }
  }

  .summary-content {
    margin-bottom: 1.5rem;
  }

  .summary-row {
    margin-bottom: 1rem;

    .summary-label {
      font-size: 12px;
      color: #667085;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }

    .summary-amount {
      font-weight: 600;
      font-size: 16px;
      color: #1a1a1a;
    }

    .summary-amount-large {
      font-weight: 700;
      font-size: 24px;
      color: #5a60f8;
    }

    .amount-word {
      font-size: 13px;
      color: #1a1a1a;
      font-style: italic;
    }

    .priority-select {
      font-size: 13px;
    }
  }

  .highlight-row {
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 6px;
    margin: 1rem 0;
  }

  .payment-method-section {
    margin: 1.5rem 0;
    padding-top: 1.5rem;
    border-top: 1px solid #e4e7ec;

    .summary-label {
      margin-bottom: 0.75rem;
    }

    .payment-method-options {
      margin: 0;
      gap: 0.75rem;
    }

    .payment-option {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.75rem 1rem;
      border: 2px solid #e4e7ec;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        border-color: #5a60f8;
        background-color: #f9fafb;
      }

      &.active {
        border-color: #5a60f8;
        background-color: #f0f0ff;
      }

      .payment-radio {
        display: flex;
        align-items: center;
        justify-content: center;

        .radio-circle {
          width: 20px;
          height: 20px;
          border: 2px solid #667085;
          border-radius: 50%;
          position: relative;
          transition: all 0.2s ease;

          &.checked {
            border-color: #5a60f8;

            &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 10px;
              height: 10px;
              background-color: #5a60f8;
              border-radius: 50%;
            }
          }
        }
      }

      .payment-icon {
        color: #667085;
        transition: color 0.2s ease;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
      }

      &.active {
        .payment-icon {
          color: #5a60f8;
        }

        span {
          color: #5a60f8;
        }
      }
    }
  }

  .confirm-button {
    margin-top: 1.5rem;
    font-weight: 600;
    padding: 0.75rem;
  }
}
</style>
